import React from 'react'

export default function Footer() {
    const currentYear = new Date().getFullYear();

  return (
    <div className="container-fluid pt-4 px-4">
      <div className="bg-light rounded-top p-4">
        <div className="d-flex justify-content-between align-items-center">
          <div className="text-start">
            &copy; {currentYear} <a href="#">AZM Rehab Centre</a>, All Rights Reserved.
          </div>
          <div className="text-end">
             Powered By <a href="#">NexusGen Software</a>
          </div>
        </div>
      </div>
    </div>
  )
}
